import script from "./CustomVoiceLearning.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomVoiceLearning.vue?vue&type=script&lang=ts&setup=true"

import "./CustomVoiceLearning.vue?vue&type=style&index=0&id=2b435795&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b435795"]])

export default __exports__